module.exports = __webpack_public_path__ + "static/ROI_Calculator-f03cb8306af34c9214db6d3d0971a43d.png";